import {COEFFICIENTS} from "./coefficients";

export const MIN_PLAYERS_COUNT = 4;
export const MAX_PLAYERS_COUNT = 14;
export const MAX_PLAYERS_IN_GAME_COUNT = 5;
export const MAX_GAME_TIME = 40 * 60 * 1000; //time in ms
export const PLAYER_TYPES = ["FIELD_PLAYER", "GOALKEEPER"];

export const FIELD_PLAYER_EVENTS = Object.keys(COEFFICIENTS).filter(key => !["SAVES", "MISSED_BALLS"].includes(key))
export const GOALKEEPER_EVENTS = Object.keys(COEFFICIENTS).filter(key => !["SELECTIONS", "LOSSES"].includes(key))